import { ErrorBoundary, FlexBox, Text } from '@dixa/lib-shared-habla';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { ElevioCard } from '../../integrations/elevio/src/components/ElevioCard';
import { KnowledgeErrorPlaceholder } from '../../integrations/elevio/src/components/KnowledgeErrorPlaceholder';
import { KnowledgeSuggestions } from '../../integrations/knowledge/components/knowledgeSuggestions';

import knowledgeCardStyles from './KnowledgeCard.module.scss';

type KnowledgeCardProps = {
  isMinimized: boolean;
};
export function SuggestionCards({
  isMinimized,
}: KnowledgeCardProps): JSX.Element | null {
  const { elevioSuggestions, knowledgeSuggestions } = useFeatureFlag([
    'elevio-suggestions',
    'knowledge-suggestions',
  ]);

  return (
    <ErrorBoundary fallback={<KnowledgeErrorPlaceholder />}>
      <>
        {(elevioSuggestions || knowledgeSuggestions) && !isMinimized ? (
          /** Displayed 1st - Do not reorder this JSX */ <FlexBox
            alignItems="center"
            padding="400 300"
            className={knowledgeCardStyles.heading}
          >
            <Text.Paragraph variant="3" subdued>
              Knowledge
            </Text.Paragraph>
          </FlexBox>
        ) : null}
        {knowledgeSuggestions && (
          /**
           * Displayed 2nd - Do not reorder this JSX
           *
           * Also note that content within KnowledgeSuggestions is conditionally
           * rendered depending on:
           *
           * - Whether the organisation has a knowledge base at all
           * - Whether the organisation has linked a `queueId` with a
           *   `collectionId` using the collectionUpdate mutation in the
           *   Knowledge Management Graphql API. For an up to date API schema,
           *   refer to
           *   https://knowledge.euw1.stag.dixa.io/delivery/api/alpha/graphql
           */ <div className={knowledgeCardStyles.knowledgeCard}>
            <KnowledgeSuggestions isMinimized={isMinimized} />
          </div>
        )}
        {elevioSuggestions && (
          /**
           * Displayed 3rd - Do not reorder this JSX
           *
           * Also note that content within ElevioCard is conditionally rendered
           * depending on:
           *
           * - Whether the organisation has an Elevio account at all
           *
           * If they don't have an account, we render an advertisement, see the
           * `SuggestionsNotEnabledPlaceholder` component for more details.
           */ <div className={knowledgeCardStyles.elevioCard}>
            <ElevioCard isMinimized={isMinimized} />
          </div>
        )}
      </>
    </ErrorBoundary>
  );
}
